export function Star() {
  return (
    <svg
      width="65"
      height="63"
      viewBox="0 0 65 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.9976 4.47265L20.5966 17.4649L6.284 19.5483C4.88278 19.7523 3.58776 20.4133 2.59942 21.429L2.45904 21.5778C0.120359 24.1361 0.2185 28.1108 2.71579 30.5494L13.0726 40.6623L10.6277 54.9423C10.3883 56.3403 10.6157 57.7783 11.2746 59.0338L11.367 59.2038C13.0705 62.2298 16.8792 63.3687 19.9694 61.7413L32.7711 54.9993L45.5728 61.7413C46.826 62.4013 48.2616 62.6291 49.6572 62.3893L49.8438 62.3545C53.2449 61.668 55.5048 58.3903 54.9145 54.9423L52.4688 40.6623L62.8263 30.5494C63.8403 29.5593 64.5001 28.262 64.7037 26.8583L64.7279 26.673C65.1292 23.2193 62.7152 20.0515 59.2581 19.5483L44.9448 17.4649L38.5446 4.47265C37.9179 3.2007 36.8902 2.17117 35.6204 1.54343C32.4318 -0.0330011 28.5713 1.27846 26.9976 4.47265Z"
        fill="currentColor"
      />
    </svg>
  );
}
